import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';

export const BankPromoButton = styled(Button)<{
  $isBirkartBanner: boolean;
  $currentLanguage: string;
}>`
  background-color: #ff0039;
  color: ${({ theme }) => theme.palette.system.white};
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  gap: 15px;
  margin: 0 auto;

  ${({ $isBirkartBanner, $currentLanguage }) =>
    $isBirkartBanner &&
    css`
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('/images/birbank/birkart-${$currentLanguage}.svg');
    `}
`;
